// extracted by mini-css-extract-plugin
export default {"userInfo":"UserDropDownMenuItem-userInfo_HQV6k","sudo":"UserDropDownMenuItem-sudo_eJ3ES","dropdownItem":"UserDropDownMenuItem-dropdownItem_rkesS"};